import { LOCATION_LIST, TRAFFIC_MONITORING_LIST, TRAFFIC_VOLUMNE_LIST } from "../pages/Location/constants";
import { useNavigate } from "react-router-dom";
import "./LocationSelectPage.css";

const OPTIONS = [
    { value: LOCATION_LIST, label: LOCATION_LIST },
    { value: TRAFFIC_VOLUMNE_LIST, label: TRAFFIC_VOLUMNE_LIST },
    { value: TRAFFIC_MONITORING_LIST, label: TRAFFIC_MONITORING_LIST },
]

export default function LocationSelectPage(props) {
    const navigate = useNavigate();

    const handleViewTypeChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === TRAFFIC_VOLUMNE_LIST) {
            navigate("/traffic");
        }
        if (selectedValue === TRAFFIC_MONITORING_LIST) {
            navigate("/traffic-monitoring");
        }
        if (selectedValue === LOCATION_LIST) {
            navigate("/location");
        }
    };
    return (
        <div className="location-selectors-container" style={{ padding: '0 1rem', ...props?.style }}>
            <select className="location-view-type-selector" value={props.selected || LOCATION_LIST} onChange={handleViewTypeChange}>
                {OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}